import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { HttpService } from './http.service';
import { DeliveryRound } from '@models/delivery-round.model';
import { SaveRoundModel } from '@models/save-round.model';
import { ResponseModel } from '@models/response.model';
import { PreviewOptimise } from '@models/preview-optimise.model';
import {
  CentralKitchenAddress,
  DeliveryRoundSettings,
} from '@models/delivery-round-settings.model';

@Injectable({
  providedIn: 'root',
})
export class DeliveryRoundService {
  private readonly roundsApi = `${environment.portageUrl}/delivery-rounds`;
  private httpService = inject(HttpService);

  listRounds(): Observable<DeliveryRound[]> {
    return this.httpService.get(`${this.roundsApi}`);
  }

  createRound(createRound: Partial<SaveRoundModel>): Observable<ResponseModel> {
    return this.httpService.post(`${this.roundsApi}`, createRound);
  }

  updateRound(updateRound: SaveRoundModel): Observable<ResponseModel> {
    return this.httpService.patch(`${this.roundsApi}`, updateRound);
  }

  deleteRound(id: number): Observable<ResponseModel> {
    return this.httpService.delete(`${this.roundsApi}/${id}`);
  }

  previewOptimise(roundIds: number[]): Observable<PreviewOptimise> {
    return this.httpService.post(`${this.roundsApi}/preview-optimise`, {
      round_ids: roundIds,
    });
  }

  optimiseSelected(roundIds: number[]): Observable<ResponseModel> {
    return this.httpService.post(`${this.roundsApi}/optimise-selected`, {
      round_ids: roundIds,
    });
  }

  getSettings(): Observable<DeliveryRoundSettings> {
    return this.httpService.get(`${this.roundsApi}/settings`);
  }

  updateCentralKitchenAddress(
    address: CentralKitchenAddress
  ): Observable<ResponseModel> {
    return this.httpService.patch(
      `${this.roundsApi}/settings/central-kitchen-address`,
      address
    );
  }
}
